import React from "react";

const Row = ({ children, className = "" }) => {
  return (
    <div className={`w-full overflow-x-auto `}>
      <div
        className={`
          flex flex-wrap gap-3 sm:gap-4 md:gap-5 items-start h-auto 
          max-w-300px sm:max-w-[600px] md:max-w-[800px] lg:max-w-[1200] xl:max-w-[100%]
          ${className}
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default Row;

// import React from "react";

// const Row = ({ children, className = "" }) => {
//   return (
//     <div className={`flex flex-wrap gap-3 sm:gap-4 md:gap-5 items-start w-full ${className}`}>
//       {children}
//     </div>
//   );
// };

// export default Row;

// import React from "react";

// const Row = ({ children, className = "" }) => {
//   return (
//     <div className={`inline-flex flex-wrap gap-3 sm:gap-4 md:gap-5 items-start w-full ${className}`}>
//       {/* {children} */}
//       {React.Children.map(children, (child) => (
//         <div className="w-full sm:w-[48%] md:w-[32%] lg:w-[24%]">{child}</div>
//       ))}
//     </div>
//   );
// };

// export default Row;
